import { createTheme } from "@mui/material/styles";
import { toast } from "react-toastify";

export const theme = createTheme({
  palette: {
    primary: {
      main: '#367C2B', // Green
    },
    secondary: {
      main: '#FFDE00', // Yellow
    },
    text: {
      primary: '#000000', // Black
    },
  },
  typography: {
    fontFamily: 'Open Sans, sans-serif',
  },
  components: {
    // MaterialTable toolbar and selection text styling
    MuiToolbar: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            color: '#000000', // Black color for selection text
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body2: {
          color: '#000000', // Black color for body text including selection count
        },
      },
    },
  },
});

export const notify_failed_multipleLocation = (locationOne, locationTwo) => {
  toast.error(
    "Orders from multiple location are selected.  i.e. " +
      locationOne +
      " and " +
      locationTwo
  );
};

export const notify_failed_multipleShipping = (firstSO, secondSO) => {
  toast.error(
    "Can't change load for different shipping order. i.e. " +
      firstSO +
      " and " +
      secondSO
  );
};

export const AUDIT_DIALOG_TEXT = "I hereby confirm that I have taken delivery of named products from named collection address and have delivered them to the named destination country. This information can be verified on the basis of our business document in the community territory.";
export const PLANNED_LOADING_DATE_ERROR_TEXT="Planned loading date is greater than arrival date";
export const ARRIVAL_DATE_ERROR_TEXT="Arrival date is lesser than planned loading date";
export const INVALID_DATE_ERROR_TEXT="Date must not be earlier than today.";
export const WITHOUT_DECLARATION_WARNING_TEXT = "Do you want to report machines without declaration? If yes, build will keep on showing on AVIS page until you declare them.";
export const ARRIVAL_DEVIATION_WARNING_TEXT = "Are you sure you want to deliver COMAR {comar} days after depature?";
export const YELLOW = "yellow";
export const BLUE = "blue";
export const GREEN = "green";
export const WHITE = "white";
export const RED = "red";
export const CODE_YELLOW = "#FFF29A";
export const CODE_GREEN = "#BBD3B7";
export const CODE_BLUE = "#C4DAED";
export const CODE_RED = "#f76a6a";
export const CODE_JD_LINK = "JdLink Data";
export const CODE_MAINCHAIN = "Mainchain Data";
export const CODE_AVIS = "FOM Estimate";
export const CODE_FORWARDER = "Forwarder Data";